module.exports = __webpack_public_path__ + "static/media/event-time-icon--red.090c7e7f.svg";